import React, { Component } from 'react';
import CheckoutContext from '../CheckoutContext';
import { EventBus, Utility } from 'src/helpers/new';
import { RouteComponentProps, withRouter } from 'src/hoc/withRouter';
import { Col } from 'react-bootstrap';
import CouponArea from '../StepCheckout/OrderSummary/CouponArea';
import './TaxCalculation.scss';
import { isEmpty } from 'lodash';

interface IProps extends RouteComponentProps {
    couponDiscount: number;
    promoDiscount: number;
    totalPrice: number;
    getCartId: any;
    getIsLoggedInFlag: any;
    isSinglePageCheckout: boolean;
}
interface IState {
    taxes: number;
}
class TaxCalculation extends Component<IProps, IState> {
    static readonly contextType = CheckoutContext;
    context!: React.ContextType<typeof CheckoutContext>;

    prevContext: any;
    packageId = '';
    bundleId = '';

    state: IState = {
        taxes: 0,
    };

    get isGetPriceCall() {
        const isValidContact = Utility.isNoEmptyFields(['firstName', 'lastName', 'email'], this.context.contact);
        const isValidResidential = Utility.isNoEmptyFields(['zipCode', 'state'], this.context.residentialAddress);
        const isValidEmail = Utility.validateEmail(this.context.contact?.email);
        const isValiZipcode = Utility.validateZipCode(
            this.context?.residentialAddress?.zipCode ?? this.context?.user?.residentialAddress?.zipCode,
        );
        const isStateSelected = this.context.residentialAddress?.state !== 'none';
        return isValidContact && isValidResidential && isValidEmail && isValiZipcode && isStateSelected;
    }
    componentDidMount() {
        EventBus.on('set-tax-value', this.updateTaxString);
        this.context.getPrice();
        this.prevContext = this.context;
    }

    componentDidUpdate() {
        if (this.context.couponCode !== this.prevContext.couponCode || this.context.isPriceUpdate) {
            if (this.isGetPriceCall) {
                this.context.getPrice();
            }
            if (this.context.isPriceUpdate) {
                this.context.updateCheckoutState({ isPriceUpdate: false });
            }
        }
        this.prevContext = this.context;
    }

    componentWillUnmount() {
        EventBus.remove('set-tax-value', this.updateTaxString);
    }

    updateTaxString = (event: any) => {
        const taxes = event.detail;
        this.setState({
            taxes,
        });
    };

    render() {
        const { couponDiscount, promoDiscount, totalPrice, isSinglePageCheckout } = this.props;
        return (
            <>
                {(this.state.taxes && this.context.currentTab !== 0) || (this.state.taxes && isSinglePageCheckout) ? (
                    <Col className='col-wrapper'>
                        <span>Tax</span>
                        <span>{global.USCurrency.format(this.state.taxes)}</span>
                    </Col>
                ) : null}

                {couponDiscount ||
                promoDiscount ||
                (this.state.taxes && this.context.currentTab !== 0) ||
                (this.state.taxes && isSinglePageCheckout) ? (
                    <hr />
                ) : null}

                {isSinglePageCheckout && (
                    <Col className='apply-discount-wrapper'>
                        <CouponArea isPayment={true} />
                    </Col>
                )}

                <Col className='col-wrapper'>
                    <span className='bold-text'>Total to pay</span>
                    <span>{global.USCurrency.format(totalPrice + this.state.taxes)}</span>
                </Col>
            </>
        );
    }
}

export default withRouter(TaxCalculation);
